angular
  .module 'gym.components'
  .directive 'reportMonthFilter', ->
    restrict: 'E'
    template: require('templates/components/reports/report_month_filter.html.slim')
    controller: ($scope, Months) ->

      $scope.months = Months
